const rankings = [
  { rank: 1, title: '时空穿梭者：纪元重启', score: '9.2', tag: '科幻巨制', trend: 'up', change: '+2' },
  { rank: 2, title: '暗夜追踪者', score: '8.8', tag: '悬疑推理', trend: 'up', change: '+5' },
  { rank: 3, title: '帝国荣耀：浴火重生', score: '9.5', tag: '高分经典', trend: 'down', change: '-1' },
  { rank: 4, title: '武林风云录', score: '9.0', tag: '动作大片', trend: 'up', change: '+3' },
  { rank: 5, title: '夏日的约定', score: '8.5', tag: '浪漫爱情', trend: 'new', change: 'NEW' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              热播排行
            </h2>
            <p className="mt-2 text-sm text-foreground-500">本周最受欢迎影片 TOP 5</p>
          </div>
          <div className="flex gap-2">
            <span className="px-4 py-1.5 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap">本周</span>
            <span className="px-4 py-1.5 rounded-full bg-background-100 text-foreground-600 text-sm font-medium whitespace-nowrap">本月</span>
          </div>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer no-underline group"
            >
              {/* Rank */}
              <div className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`text-lg font-extrabold ${
                      item.rank === 1 ? 'text-accent-500' : item.rank === 2 ? 'text-secondary-500' : 'text-primary-400'
                    }`}
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-lg font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.tag}</span>
              </div>

              {/* Score */}
              <div className="shrink-0 text-right">
                <div className="text-lg font-bold text-accent-500" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.score}
                </div>
              </div>

              {/* Trend */}
              <div className="shrink-0 w-14 text-right">
                <span
                  className={`inline-flex items-center gap-0.5 text-xs font-semibold whitespace-nowrap ${
                    item.trend === 'up'
                      ? 'text-green-600'
                      : item.trend === 'down'
                      ? 'text-red-500'
                      : 'text-accent-500'
                  }`}
                >
                  {item.trend === 'up' && <i className="ri-arrow-up-s-fill"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-s-fill"></i>}
                  {item.change}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}